module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_3016.8a1b97af.png";